<template>
  <main>
    <mdb-container>
      <mdb-row center>
        <mdb-col col="12" class="text-center mt-3">
          <h1 class="font-weight-bold pentagon-red">{{ $t('boards.current_heading') }}</h1>
        </mdb-col>

        <Bestuur
          name="Jonkman"
          year="2025 - 2026"
          preases="D. Jonkman"
          abactis="S. Hartings"
          questor="T. van Lent"
          col-size="12"
        />

      </mdb-row>

      <mdb-row>
        <mdb-col col="12" class="text-center mt-3">
          <h1 class="font-weight-bold pentagon-green">{{ $t('boards.former_heading') }}</h1>
        </mdb-col>

        <Bestuur
          name="Elling"
          year="2024 - 2025"
          preases="L. Elling"
          abactis="KJ. Groenen"
          questor="N. Broer"
          col-size="12"
        />

        <Bestuur
          name="Immerzeel"
          year="2023 - 2024"
          preases="J. Immerzeel"
          abactis="J. Zeilstra"
          questor="T. Pouw"
          col-size="12"
        />

        <Bestuur
          name="Stunnenberg"
          year="2022 - 2023"
          preases="N. Stunnenberg"
          abactis="S. van der Erf"
          questor="F. Verhoeff"
          col-size="12"
        />

        <Bestuur
          name="Wijte"
          year="2021 - 2022"
          preases="W. Wijte"
          abactis="J. Balkenende"
          questor="P. Klarich"
          col-size="12"
        />

        <Bestuur
          name="Van Stenus"
          year="2020 - 2021"
          preases="Q. van Stenus"
          abactis="D. Genet"
          questor="J. van der Lei"
          col-size="12"
        />

        <Bestuur
          name="Wentholt"
          year="2019 - 2020"
          preases="S.C.L. Wentholt"
          abactis="R. Farid Mojtahedi"
          questor="M. Rezaei Ghavamabadi"
        />

        <Bestuur
          name="Smit"
          year="2018 - 2019"
          preases="M. Smit"
          abactis="C. van Dasler"
          questor="M. Kollaard"
        />

        <Bestuur
          name="Van Leeuwen"
          year="2017 - 2018"
          preases="R. van Leeuwen"
          abactis="J. Langedijk"
          questor="O. Groen"
        />

        <Bestuur
          name="Wilde"
          year="2016 - 2017"
          preases="T. Wilde"
          abactis="R. Meijer"
          questor="S. Thijsen"
        />

        <Bestuur
          name="Siebeler"
          year="2015 - 2016"
          preases="T. Siebeler"
          abactis="L. v. Amerongen"
          questor="T. Verwijen"
        />

        <Bestuur
          name="Stokhof"
          year="2014 - 2015"
          preases="M. Stokhof"
          abactis="D. Wijman"
          questor="G. Vermeulen"
        />

        <Bestuur
          name="Visser"
          year="2013 - 2014 ( II )"
          preases="D. Visser"
          abactis="B. van Oorschot"
          questor="D. Verstift"
        />

        <Bestuur
          name="De Voogd"
          year="2013 - 2014 ( I )"
          preases="F. de Voogd"
          abactis="B. van Oorschot"
          questor="D. Verstift"
        />

        <Bestuur
          name="De Voogd"
          year="2012 - 2013"
          preases="F. de Voogd"
          abactis="R. Felt"
          questor="R. de Graaf"
        />

        <Bestuur
          name="Vaneker"
          year="2011 - 2012 ( II )"
          preases="E. Vaneker"
          abactis="T. Swinkels"
          questor="B. Koning"
        />

        <Bestuur
          name="Miltenburg"
          year="2011 - 2012 ( I )"
          preases="R. Miltenburg"
          questor="B. Koning"
          abactis="T. Swinkels"
        />

        <Bestuur
          name="Ramlawi"
          year="2010 - 2011"
          preases="A. Ramlawi"
          questor="R. Miltenburg"
          abactis="J. Jager ✞"
        />

        <Bestuur
          name="Ceulemans"
          year="2009 - 2010 ( II )"
          preases="N. Ceulemans"
          questor="R. Peeters"
          abactis="A. Ramlawi"
        />

        <Bestuur
          name="Kunst"
          year="2009 - 2010 ( I )"
          preases="J. Kunst"
          abactis="A. Ramlawi"
          questor="R. Peeters"
        />

        <Bestuur
          name="Piersma"
          year="2008 - 2009"
          preases="J. Piersma"
          questor="M. van Werkhoven"
          abactis="W. Gijsbers"
        />

        <Bestuur
          name="Roodenburg"
          year="2007 - 2008 ( II )"
          preases="M. Roodenburg"
          questor="N. Beeftink"
          abactis="R. van den Berg"
        />

        <Bestuur
          name="Roodenburg ( I ) "
          year="2007 - 2008"
          preases="M. Roodenburg"
          questor="N. Beeftink"
          abactis="N. Bassie"
        />

        <Bestuur
          name="Van de Laar "
          year="2006 - 2007"
          preases="T. van de Laar"
          questor="P. van Ulden"
          abactis="J. Piersma"
        />

        <Bestuur
          name="Verhoef"
          year="2005 - 2006 ( II )"
          preases="P. Verhoef"
          questor="F. van Altena"
          abactis="C. Kolder"
        />

        <Bestuur
          name="Verhoef"
          year="2005 - 2006 ( I )"
          preases="P. Verhoef"
          questor="F. van Altena"
          abactis="J. Kunst"
        />

        <Bestuur
          name="Koelewijn"
          year="2004 - 2005"
          preases="L. Koelewijn"
          questor="T. Peeters"
          abactis="Q. Koekenbier"
        />

        <Bestuur
          name="Geurst"
          year="2003 - 2004"
          preases="P. Geurst"
          questor="P. Perizonius"
          abactis="S. van groeningen"
        />

        <Bestuur
          name="Kleijn"
          year="2002 - 2003"
          preases="F. de Kleijn"
          questor="P. Geurts"
          abactis="M. van Faassen"
        />

        <Bestuur
          name="Derkx"
          year="2001 - 2002"
          preases="J. Derkx"
          questor="J. Hannink"
          abactis="F. Wijlens"
        />

        <Bestuur
          name="Stevens"
          year="2000 - 2001"
          preases="W. Stevens"
          questor="T. Foolen"
          abactis="S. Rakhorst"
        />

        <Bestuur
          name="Foolen"
          year="1999 - 2000"
          preases="T. Foolen"
          questor="M. Weevers"
          abactis="L. Santing"
        />

        <Bestuur
          name="Van den Brink"
          year="1998 - 1999"
          preases="J. van den Brink"
          questor="W. Stevens"
          abactis="S. Buwalda"
        />

        <Bestuur
          name="Aafjes"
          year="1997 - 1998"
          preases="M. Aafjes"
          questor="B. Weijers"
          abactis="C. van den Berg"
        />

        <Bestuur
          name="Lockhorst"
          year="1996 - 1997"
          preases="A. Lockhorst"
          questor="B. Weijers"
          abactis="A. Kuiters"
        />

        <Bestuur
          name="Van Voorst"
          year="1995 - 1996"
          preases="D. van Voorst"
          questor="J. Visser"
          abactis="W. DuPon"
        />

        <Bestuur
          name="Pere"
          year="1994 - 1995"
          preases="R. Pere"
          questor="D. van Voorst"
          abactis="R. van de Peppel"
        />

        <Bestuur
          name="Veldhuizen"
          year="1993 - 1994"
          preases="D. Veldhuizen"
          questor="D. van Koningsveld"
          abactis="D. van der Leij"
        />

        <Bestuur
          name="Winkel"
          year="1992 - 1993"
          preases="W. Winkel"
          questor="M. van Laer"
          abactis="S. Thiecke"
        />

        <Bestuur
          name="Dekker"
          year="1991 - 1992"
          preases="R. Dekker"
          questor="H. Schumacher"
          abactis="J. Brauns"
        />

        <Bestuur
          name="Van Gelder"
          year="1990 - 1991"
          preases="N. van Gelder"
          questor="M. Edixhoven"
          abactis="N. Boelen"
        />

        <Bestuur
          name="Reinigert"
          :year="$t('boards.founding_year')"
          preases="H. Reinigert"
          questor="S. Boelen"
          abactis="J. Brauns"
        />
      </mdb-row>
    </mdb-container>
  </main>
</template>

<script>
import { mdbRow, mdbCol, mdbContainer } from 'mdbvue';
import Bestuur from '../components/Bestuur';

export default {
  name: 'Leden',
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Bestuur,
  },
  data() {
    return {

    };
  },
  created() {
    this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
  },
};
</script>

<style scoped>

</style>
